module.exports = __webpack_public_path__ + "img/balk-shape.81ee48bcba85c95acd67069d3ed36a5f.svg";